import React from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { fetchJobs } from "../features/jobs/jobsSlice";

const Sidebar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleFilter = (type) => {
    dispatch(fetchJobs(type));
    navigate("/");
  };
  return (
    <div className="sidebar">
      <nav>
        <ul className="space-y-4">
          <li>
            <button
              className="main-menu menu-active"
              id="lws-alljobs-menu"
              onClick={() => handleFilter("All")}
            >
              <i className="fa-solid fa-briefcase" />
              <span> All Available Jobs</span>
            </button>
            <ul className="space-y-6 lg:space-y-2 ">
              <li>
                <button
                  className="sub-menu"
                  id="lws-internship-menu"
                  onClick={() => handleFilter("Internship")}
                >
                  <i className="fa-solid fa-stop !text-[#FF5757]" />
                  Internship
                </button>
              </li>
              <li>
                <button
                  className="sub-menu"
                  onClick={() => handleFilter("Full Time")}
                  id="lws-fulltime-menu"
                >
                  <i className="fa-solid fa-stop !text-[#FF8A00]" />
                  Full Time
                </button>
              </li>
              <li>
                <button
                  className="sub-menu"
                  // href="/jobs/remote"
                  onClick={() => handleFilter("Remote")}
                  id="lws-remote-menu"
                >
                  <i className="fa-solid fa-stop !text-[#56E5C4]" />
                  Remote
                </button>
              </li>
            </ul>
          </li>
          <li>
            <Link to="/newjob" className="main-menu" id="lws-addJob-menu">
              <i className="fa-solid fa-file-circle-plus" />
              <span>Add NewJob</span>
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
